<template>
  <client-only>
    <TransitionRoot :show="isOpen" as="template">
      <Dialog
        component-name="modal-bath-concept-related"
        data-skin="white"
        class="relative z-50"
        data-lenis-prevent
      >
        <TransitionChild
          enter="transition-opacity duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <!-- The backdrop, rendered as a fixed sibling to the panel container -->
          <div
            class="modal-backdrop"
            aria-hidden="true"
            @click="emit('close')"
          ></div>
        </TransitionChild>

        <!-- Full-screen scrollable container -->
        <div
          class="pointer-events-none overflow-clip fixed inset-0 flex justify-end w-full h-full"
        >
          <!-- Container to center the panel -->
          <div class="flex justify-end items-stretch w-full h-full max-h-full">
            <TransitionChild
              enter="transition-transform duration-300 ease-out delay-200"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transition-transform duration-300 ease-in"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
            >
              <!-- The actual dialog panel -->
              <component
                :is="$device.isMobile ? 'div' : DialogPanel"
                data-skin="white"
                class="pointer-events-auto flex flex-col justify-between w-[calc(100vw-60px)] max-w-[650px] h-full max-h-full bg-skin-base"
              >
                <div
                  class="flex flex-col gap-2xl grow overflow-y-auto w-full p-edge"
                >
                  <h1
                    class="text-heading-4"
                    v-html="$t.labels.related_projects"
                  ></h1>
                  <div class="grid grid-cols-2 gap-xs">
                    <btn
                      v-for="item in staticItems"
                      :action="{ to: `/bath-concept/${item.slug}` }"
                      class="aspect-1/1 bg-skin-muted w-full overflow-hidden cursor-pointer"
                    >
                      <img
                        :src="item.cover.asset.src"
                        :alt="item.cover.asset.alt"
                        class="block w-full aspect-1/1 transition-transform duration-1000 group-hover/btn:scale-105"
                      />
                    </btn>
                  </div>
                </div>
              </component>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </client-only>
</template>

<script setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
} from "@headlessui/vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
  items: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["close"]);
const staticItems = ref([...props.items]);
const route = useRoute();

watch(
  () => route.name,
  (newVal, oldVal) => {
    emit("close");
  }
);

watch(
  () => props.isOpen,
  (newVal, oldVal) => {
    if (newVal) {
      staticItems.value = [...props.items];
    }
  }
);
</script>
